import { motion } from "framer-motion";

const ImageGroup = () => {
  return (
    <div className="flex flex-col gap-10 items-center justify-start">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
      >
        <img
          src="/TriNetra_removebg.png"
          alt="TriNetra"
          // className="w-60 object-contain bg-gradient-to-b from-[#2D2D2D] to-[#000000] rounded-md px-2"
          // className="w-60 object-contain bg-gradient-to-b from-white to-[#000000] rounded-md px-2"
          className="w-60 object-contain bg-white opacity-95 rounded-lg py-1 px-2"
        />
      </motion.div>

      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
      >
        <img
          src="/AI_removebg.png"
          alt="AI &"
          // className="w-40 object-contain bg-gradient-to-b from-[#0A0F24] to-[#de1028] rounded-md p-2"
          className="w-40 object-contain bg-white opacity-95 rounded-lg p-2"
        />
      </motion.div> */}
    </div>
  );
};

export default ImageGroup;
